import { FileDown } from "lucide-react";

import { downloadReport, type PdfReportContext } from "@/lib/download";

const BASE_CLASS =
  "inline-flex items-center gap-1.5 text-sm px-2 py-1 rounded transition-colors text-muted-foreground hover:text-foreground hover:bg-muted";

/**
 * Downloads a report as PDF using the existing client-side jsPDF renderer.
 * Styled to match CopyButton / DOCXButton in the report export bar.
 */
export function PDFButton({
  content,
  title,
  fileBase,
  projectTitle,
  meta,
}: {
  content: string;
  title: string;
  fileBase: string;
  projectTitle: string;
  meta: PdfReportContext;
}) {
  const handleClick = () => {
    downloadReport(content, title, fileBase, "pdf", { projectTitle, ...meta });
  };

  return (
    <button onClick={handleClick} className={BASE_CLASS} title="Download as PDF">
      <FileDown className="w-3.5 h-3.5" />
      PDF
    </button>
  );
}
